<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)"  size="medium" color="#fff" type="ball-spin" [fullScreen]="true" ><p style="color: white;">Vui lòng chờ</p></ngx-spinner>
